import { primaryNavigation } from "@holocron/shared";
import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { SmartLink } from "../common/SmartLink";

const contactHref = "/contact";

function linkClassName(isActive: boolean) {
  return `site-nav-link${isActive ? " is-active" : ""}`;
}

export function SiteHeader() {
  const location = useLocation();
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  return (
    <header className="site-header">
      <div className="site-header-inner">
        <SmartLink className="brand" href="/">
          <img alt="Holocron Security logo" src="/assets/img/holocron-logo.svg" />
        </SmartLink>

        <button
          aria-expanded={isMobileOpen}
          aria-label="Toggle navigation menu"
          className="menu-button"
          onClick={() => setIsMobileOpen((current) => !current)}
          type="button"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`site-nav${isMobileOpen ? " is-open" : ""}`}>
          {primaryNavigation
            .filter((link) => link.href !== "/")
            .map((link) => (
              <NavLink
                key={link.href}
                className={({ isActive }) => linkClassName(isActive)}
                to={link.href}
              >
                {link.label}
              </NavLink>
            ))}

          <SmartLink className="header-signin header-signin-mobile" href={contactHref}>
            Request Demo
          </SmartLink>
        </nav>

        <div className="site-header-actions">
          <SmartLink className="header-signin" href={contactHref}>
            Request Demo
          </SmartLink>
        </div>
      </div>
    </header>
  );
}
